import { Link } from "expo-router";
import * as WebBrowser from "expo-web-browser";
import React from "react";
import { Platform, Pressable, PressableProps } from "react-native";

export function ExternalLink(props: Omit<React.ComponentProps<typeof Link>, "href"> & { href: string }) {
  function handlePress() {
    void WebBrowser.openBrowserAsync(props.href, {
      presentationStyle: WebBrowser.WebBrowserPresentationStyle.FORM_SHEET,
    });
  }

  if (Platform.OS === "ios") {
    return (
      <Pressable role="link" {...(props as PressableProps)} onPress={handlePress}>
        {props.children}
      </Pressable>
    );
  } else {
    return (
      <Link role="link" target="_blank" {...props} href={props.href as React.ComponentProps<typeof Link>["href"]}>
        {props.children}
      </Link>
    );
  }
}
